import { render, staticRenderFns } from "./department-info.vue?vue&type=template&id=d2490aa2&scoped=true&"
import script from "./department-info.vue?vue&type=script&lang=js&"
export * from "./department-info.vue?vue&type=script&lang=js&"
import style0 from "./department-info.vue?vue&type=style&index=0&id=d2490aa2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2490aa2",
  null
  
)

export default component.exports